import TaggingTool from '@js/analysis/pages/TaggingTool.vue';
import Highlight from '@js/analysis/pages/Highlight.vue';
import Capture from '@js/analysis/pages/Capture.vue';
import Vue from 'vue';
import Router from 'vue-router';
import laroute from '@laroute';
import store from '@videotools/js/store';

Vue.use(Router);

export const ROUTE_NAMES = { // todo -check in header if is tagging tool to show settigns
	TAGGING_TOOL: 'TaggingTool',
	HIGHLIGHT:    'Highlight',
	CAPTURE:      'Capture',
	ANALYZE:      'Analyze',
};

// Placeholder components for routes that don't exist yet
const Analyze = {
	template: '<div>Analyze Tool Placeholder</div>',
	name:     'Analyze',
};

const routes = [];

routes.push({
	path:     '/event/:id/one',
	redirect: '/event/:id/one/tagging',
	meta:     {
		requiresAuth: true,
	},
});

routes.push({
	path:      '/event/:id/one/tagging',
	name:      ROUTE_NAMES.TAGGING_TOOL,
	component: TaggingTool,
	meta:      {
		requiresAuth: true,
	},
});

const isDownloadable = store.getters['event/isDownloadable'];
const canUseHighlightTool = store.getters['permissions/canUseHighlightTool'];

if (isDownloadable && canUseHighlightTool) {
	routes.push({
		path:      '/event/:id/one/highlight',
		name:      ROUTE_NAMES.HIGHLIGHT,
		component: Highlight,
		meta:      {
			requiresAuth: true,
		},
	});
}

routes.push({
	path:      '/event/:id/one/highlight',
	name:      ROUTE_NAMES.HIGHLIGHT,
	component: Highlight,
	meta:      {
		requiresAuth: true,
	},
});
routes.push({
	path:      '/event/:id/one/capture',
	name:      ROUTE_NAMES.CAPTURE,
	component: Capture,
	meta:      {
		requiresAuth: true,
	},
});

routes.push({
	path:      '/event/:id/one/analyze',
	name:      ROUTE_NAMES.ANALYZE,
	component: Analyze,
	meta:      {
		requiresAuth: true,
	},
});

const router = new Router({
	mode: 'history',
	routes,
});

const isLoggedIn = (() => {
	const metaAsportUserContextId = document.head.querySelector("meta[name='asport-user-context-id']");
	const userContextId = metaAsportUserContextId ? metaAsportUserContextId.getAttribute('content') : null;
	return userContextId !== null;
})();

router.beforeEach((to, from, next) => {
	if (to.matched.some((rec) => rec.meta.requiresAuth)) {
		if (isLoggedIn) {
			// Exit edit mode if we're navigating between different routes
			if (from.name !== to.name && store.getters['eventTagEdit/isSingleEdit']) {
				store.dispatch('eventTagEdit/clearSelection');
			}
			next();
		} else {
			window.location = laroute.route('login');
		}
	}
});

export default router;
